/**
 * HomeENDemoStockPageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENDemoStockPageContent
 */

import { useHomeENDemoStockPageContentLogic } from '@/hooks/traits/useHomeENDemoStockPageContentLogic';
import type { HomeENDemoStockPageContentConfig } from '@/hooks/traits/useHomeENDemoStockPageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoStockItem } from '@app/shared';
import { HomeENDemoStockPageListView } from '@/components/traits/HomeENDemoStockPageListView';
import { Typography } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { HomeENDemoStockPageUnitsChartView } from '@/components/traits/HomeENDemoStockPageUnitsChartView';
import { HomeENDemoStockPageStatsView } from '@/components/traits/HomeENDemoStockPageStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENDemoStockPageContentViewProps {
  config?: Partial<HomeENDemoStockPageContentConfig>;
}

export function HomeENDemoStockPageContentView({ config: propsConfig }: HomeENDemoStockPageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENDemoStockPageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoStockItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENDemoStockPageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-3" gap="md" direction="vertical"><Stack direction="vertical" gap="none"><Typography content={renderPatternValue(__t("std-almadar-demo-stock-page:page.title"))} variant="h3" /><Typography content={renderPatternValue(__t("std-almadar-demo-stock-page:page.subtitle"))} color="muted" variant="small" /></Stack><HomeENDemoStockPageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeENDemoStockPageUnitsChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeENDemoStockPageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENDemoStockPageContentView;
